import React, { useState } from 'react';
import FlightDelayScenario from './FlightDelayScenario';
import BikeQrScenario from './BikeQrScenario';

const ScenarioHub: React.FC = () => {
  const [activeScenario, setActiveScenario] = useState<'list' | 'flight' | 'bike'>('list');

  if (activeScenario === 'flight') {
    return (
      <div className="space-y-6">
        <button
          onClick={() => setActiveScenario('list')}
          className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800"
        >
          ← 返回关卡列表
        </button>
        <FlightDelayScenario />
      </div>
    );
  }

  if (activeScenario === 'bike') {
    return (
      <div className="space-y-6">
        <button
          onClick={() => setActiveScenario('list')}
          className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800"
        >
          ← 返回关卡列表
        </button>
        <BikeQrScenario />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-left">
        <h3 className="text-3xl font-bold text-gray-800 mb-2">情景模拟模块</h3>
        <p className="text-gray-600">
          第二代新增生活化场景训练，首期推出两大关卡。完成每关后可回到列表继续挑战。
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white border-2 border-blue-200 rounded-xl p-6 shadow-sm">
          <h4 className="text-xl font-bold text-blue-800 mb-2">航班延误短信辨伪</h4>
          <p className="text-sm text-gray-600 mb-4">
            同时收到真实短信与诈骗短信，通过比对关键信息标记可疑点。
          </p>
          <button
            onClick={() => setActiveScenario('flight')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition"
          >
            进入关卡
          </button>
        </div>

        <div className="bg-white border-2 border-emerald-200 rounded-xl p-6 shadow-sm">
          <h4 className="text-xl font-bold text-emerald-800 mb-2">共享单车二维码骗局</h4>
          <p className="text-sm text-gray-600 mb-4">
            在多个二维码中选择正确扫码方式，误扫将触发风险提示与原理解析。
          </p>
          <button
            onClick={() => setActiveScenario('bike')}
            className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition"
          >
            进入关卡
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScenarioHub;
